module.exports = __webpack_public_path__ + "img/gifUltraClearImg.3eefe854.gif";